import React from 'react'
import "../../CSS/Blog/marcacaoDePagina.css"


const MarcacaoDePagina = () => {
  return (
    <div>

        <h1 className='marcacaoDePaginaBlog'>Home / Blog / The Art of Curating a Luxury Perfume Collections A Symphony os Scenes and Stories</h1>

    </div>
  )
}

export default MarcacaoDePagina